/* eslint-disable @typescript-eslint/no-var-requires */

if ($hasDep('ably', '2')) {
  throw new Error('AblyRealtimeProvider is not available when ably@2 is installed. Please migrate to the new Ably API (#ably-v3-upgrade).');
}
export const AblyRealtimeProvider = require('./compat/AblyRealtimeProvider').AblyRealtimeProvider;